import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBG from '../../../images/ComponentImages/categoryScreenBackground.png';
import RoundScreen from '../../../components/roundScreen';

export default function Page04({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen
				titles={['Day 1', 'Back']}
				texts={['Yes your workout starts now']}
				BGImage={CategoryScreenBG}
			/>
			<RoundScreen
				title='Exercise 01 UnderHand Cable Pull Downs'
				isNumbered={false}
				rounds={[
					[
						{
							header: 'Exercise',
							value: 'UnderHand Cable Pull Downs',
						},
						{
							header: '# of sets',
							value: '1',
						},
						{
							header: 'REPS / Weight',
							value: '10 Mild',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Full Range of Motion, Loosen the Shoulders, Stretch The LATS, Warm Up',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'UnderHand  Cable Pull Downs',
						},
						{
							header: '# of sets',
							value: '2 - 3',
						},
						{
							header: 'REPS / Weight',
							value: '8 - 10 Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Up the Weight, Full Stretch and SQUEEZE',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'UnderHand  Cable Pull Downs',
						},
						{
							header: '# of sets',
							value: '4',
						},
						{
							header: 'REPS / Weight',
							value: 'Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Full on Set Till Failure',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
